<template>
    <el-dialog custom-class="dialogClass" :append-to-body="true"  :visible.sync="visible"
        :before-close="handleClose">
        <div slot="title" class="dialog-title" v-if="title">
            <div style="width: 2px;height: 16px;background: #0084FF;"></div>
            <div style="margin-left: 8px">{{ title }}</div>
        </div>
        <slot></slot>
        <span slot="footer" class="dialog-footer" v-if="showButton">
            <el-button size="mini" @click="handleClose">取 消</el-button>
            <el-button size="mini" type="primary" @click="handleConfirm">确 定</el-button>
        </span>
    </el-dialog>
</template>
 
<script>
export default {
    props: {
        title: {
            type: String,
            default: ''
        },
        visible: {
            type: Boolean,
            default: false
        },
        showButton: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        handleClose() {
            this.$emit('update:visible', false)
        },
        handleConfirm() {
            this.$emit('confirm')
        }
    }
}
</script>
 
<style lang="less">
.dialogClass /deep/.el-dialog__header {
    border-bottom: 1px solid #E5E5E5;
    padding: 12px 16px;
}

.dialogClass /deep/.el-dialog__body {
    padding: 24px 32px 32px;
}

.dialogClass /deep/.el-dialog__footer {
    border-top: 1px solid #E5E5E5;
    padding: 12px 32px;
}

.dialog-title {
    display: flex;
    align-items: center;
}

.dialogClass/deep/.el-dialog__headerbtn {
    top: 15px;
}
</style>


// WEBPACK FOOTER //
// src/zzcbpmDashboard/common/m-dialog.vue